import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { QuotesActions } from '../../../@store/quotes/quotes.actions';
import {
  selectDuplicatedQuoteError,
  selectDuplicatedQuoteSuccess,
} from '../../../@store/quotes/quotes.selectors';

@Component({
  selector: 'ciwc-duplicate-quote-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './duplicate-quote-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicateQuoteDialogComponent {
  private readonly store = inject(Store);
  readonly duplicatedQuoteSuccess = this.store.selectSignal(selectDuplicatedQuoteSuccess);
  readonly duplicatedQuoteError = this.store.selectSignal(selectDuplicatedQuoteError);

  isDuplicating = signal(false);

  constructor(
    public dialogRef: MatDialogRef<DuplicateQuoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { quoteId: string; id: number },
  ) {
    effect(() => {
      if (this.isDuplicating()) {
        if (this.duplicatedQuoteSuccess()) {
          this.dialogRef.close();
        }

        if (this.duplicatedQuoteError()) {
          this.isDuplicating.set(false);
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isDuplicating.set(true);

    this.store.dispatch(QuotesActions.duplicateQuote({ quoteId: this.data.id.toString() }));
  }
}
